/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiKeyFromJSON, ApiKeyCreateToJSON, ApiKeyCreatedFromJSON, GetUploadUrlResponseFromJSON, GlobalStatsFromJSON, GroupFromJSON, GroupCreateToJSON, GroupUpdateToJSON, MailingListPreviewFromJSON, MembershipInfoFromJSON, MyProfileUpdateToJSON, MyStatsFromJSON, ProfileFromJSON, ProfileCreateToJSON, ProfileUpdateToJSON, RoleFromJSON, UserRankingsFromJSON, } from '../models/index';
/**
 *
 */
export class ProfilesApi extends runtime.BaseAPI {
    /**
     * Create Group
     */
    createGroupApiV1GroupsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupCreate'] == null) {
                throw new runtime.RequiredError('groupCreate', 'Required parameter "groupCreate" was null or undefined when calling createGroupApiV1GroupsPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GroupCreateToJSON(requestParameters['groupCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GroupFromJSON(jsonValue));
        });
    }
    /**
     * Create Group
     */
    createGroupApiV1GroupsPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createGroupApiV1GroupsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Mint a new API key for the current member.  The raw secret is returned exactly once, in this response; only its hash is stored, so it can never be retrieved again. Every requested permission must be one the member actually holds -- a key can never widen its owner\'s rights.
     * Create My Api Key
     */
    createMyApiKeyApiV1ProfilesMeApiKeysPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiKeyCreate'] == null) {
                throw new runtime.RequiredError('apiKeyCreate', 'Required parameter "apiKeyCreate" was null or undefined when calling createMyApiKeyApiV1ProfilesMeApiKeysPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/api-keys`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiKeyCreateToJSON(requestParameters['apiKeyCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiKeyCreatedFromJSON(jsonValue));
        });
    }
    /**
     * Mint a new API key for the current member.  The raw secret is returned exactly once, in this response; only its hash is stored, so it can never be retrieved again. Every requested permission must be one the member actually holds -- a key can never widen its owner\'s rights.
     * Create My Api Key
     */
    createMyApiKeyApiV1ProfilesMeApiKeysPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createMyApiKeyApiV1ProfilesMeApiKeysPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create Profile
     */
    createProfileApiV1ProfilesPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileCreate'] == null) {
                throw new runtime.RequiredError('profileCreate', 'Required parameter "profileCreate" was null or undefined when calling createProfileApiV1ProfilesPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProfileCreateToJSON(requestParameters['profileCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
        });
    }
    /**
     * Create Profile
     */
    createProfileApiV1ProfilesPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createProfileApiV1ProfilesPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete Profile
     */
    deleteProfileApiV1ProfilesProfileIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileId'] == null) {
                throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling deleteProfileApiV1ProfilesProfileIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/{profile_id}`.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete Profile
     */
    deleteProfileApiV1ProfilesProfileIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteProfileApiV1ProfilesProfileIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get Global Stats
     */
    getGlobalStatsApiV1StatsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/stats/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GlobalStatsFromJSON(jsonValue));
        });
    }
    /**
     * Get Global Stats
     */
    getGlobalStatsApiV1StatsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGlobalStatsApiV1StatsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get Group
     */
    getGroupApiV1GroupsGroupIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling getGroupApiV1GroupsGroupIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/{group_id}`.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GroupFromJSON(jsonValue));
        });
    }
    /**
     * Get Group
     */
    getGroupApiV1GroupsGroupIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupApiV1GroupsGroupIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Return the current user\'s membership status and history.
     * Get My Membership
     */
    getMyMembershipApiV1ProfilesMeMembershipGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/membership`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MembershipInfoFromJSON(jsonValue));
        });
    }
    /**
     * Return the current user\'s membership status and history.
     * Get My Membership
     */
    getMyMembershipApiV1ProfilesMeMembershipGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMyMembershipApiV1ProfilesMeMembershipGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns all \'action:resource\' permission strings for the current user.
     * Get My Permissions
     */
    getMyPermissionsApiV1ProfilesMePermissionsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/permissions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Returns all \'action:resource\' permission strings for the current user.
     * Get My Permissions
     */
    getMyPermissionsApiV1ProfilesMePermissionsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMyPermissionsApiV1ProfilesMePermissionsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get My Profile
     */
    getMyProfileApiV1ProfilesMeGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
        });
    }
    /**
     * Get My Profile
     */
    getMyProfileApiV1ProfilesMeGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMyProfileApiV1ProfilesMeGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get My Roles
     */
    getMyRolesApiV1ProfilesMeRolesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/roles`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get My Roles
     */
    getMyRolesApiV1ProfilesMeRolesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMyRolesApiV1ProfilesMeRolesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get My Stats
     */
    getMyStatsApiV1StatsMeGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/stats/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MyStatsFromJSON(jsonValue));
        });
    }
    /**
     * Get My Stats
     */
    getMyStatsApiV1StatsMeGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMyStatsApiV1StatsMeGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get Profile
     */
    getProfileApiV1ProfilesProfileIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileId'] == null) {
                throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling getProfileApiV1ProfilesProfileIdGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/{profile_id}`.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
        });
    }
    /**
     * Get Profile
     */
    getProfileApiV1ProfilesProfileIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProfileApiV1ProfilesProfileIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Return a member\'s membership status and history (staff/admin only).
     * Get Profile Membership
     */
    getProfileMembershipApiV1ProfilesProfileIdMembershipGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileId'] == null) {
                throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling getProfileMembershipApiV1ProfilesProfileIdMembershipGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/{profile_id}/membership`.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MembershipInfoFromJSON(jsonValue));
        });
    }
    /**
     * Return a member\'s membership status and history (staff/admin only).
     * Get Profile Membership
     */
    getProfileMembershipApiV1ProfilesProfileIdMembershipGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getProfileMembershipApiV1ProfilesProfileIdMembershipGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Rank active members by how they engage with events, per season.  For each season (plus an all-time window) members are ranked on three metrics, in order of the values we want to encourage:  * **Reactivity** — median delay between an event being published and the   member answering it (yes or no). Answering quickly lets the bagad commit   to organisers, so this is the primary metric. * **Response rate** — share of the season\'s answerable events the member   responded to. Per-season only (a cross-season rate is meaningless), so   it is omitted from the all-time window. * **Positive responses** — absolute count of \"yes\" answers, i.e. turnouts.   Secondary, but tracked because outings keep the group alive.  Only members with at least :data:`MIN_POSITIVE_RESPONSES` positive responses all-time appear, to avoid ranking one-off participants.
     * Get User Rankings
     */
    getUserRankingsApiV1StatsRankingsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/stats/rankings`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserRankingsFromJSON(jsonValue));
        });
    }
    /**
     * Rank active members by how they engage with events, per season.  For each season (plus an all-time window) members are ranked on three metrics, in order of the values we want to encourage:  * **Reactivity** — median delay between an event being published and the   member answering it (yes or no). Answering quickly lets the bagad commit   to organisers, so this is the primary metric. * **Response rate** — share of the season\'s answerable events the member   responded to. Per-season only (a cross-season rate is meaningless), so   it is omitted from the all-time window. * **Positive responses** — absolute count of \"yes\" answers, i.e. turnouts.   Secondary, but tracked because outings keep the group alive.  Only members with at least :data:`MIN_POSITIVE_RESPONSES` positive responses all-time appear, to avoid ranking one-off participants.
     * Get User Rankings
     */
    getUserRankingsApiV1StatsRankingsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getUserRankingsApiV1StatsRankingsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Groups
     */
    listGroupsApiV1GroupsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupFromJSON));
        });
    }
    /**
     * List Groups
     */
    listGroupsApiV1GroupsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupsApiV1GroupsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List the current member\'s API keys (never exposes the raw secret).
     * List My Api Keys
     */
    listMyApiKeysApiV1ProfilesMeApiKeysGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/api-keys`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiKeyFromJSON));
        });
    }
    /**
     * List the current member\'s API keys (never exposes the raw secret).
     * List My Api Keys
     */
    listMyApiKeysApiV1ProfilesMeApiKeysGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listMyApiKeysApiV1ProfilesMeApiKeysGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Profiles
     */
    listProfilesApiV1ProfilesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProfileFromJSON));
        });
    }
    /**
     * List Profiles
     */
    listProfilesApiV1ProfilesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listProfilesApiV1ProfilesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Roles
     */
    listRolesApiV1RolesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/roles/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleFromJSON));
        });
    }
    /**
     * List Roles
     */
    listRolesApiV1RolesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRolesApiV1RolesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Preview Mailing List
     */
    previewMailingListApiV1GroupsGroupIdMailingListPreviewGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling previewMailingListApiV1GroupsGroupIdMailingListPreviewGet().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/{group_id}/mailing-list/preview`.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MailingListPreviewFromJSON(jsonValue));
        });
    }
    /**
     * Preview Mailing List
     */
    previewMailingListApiV1GroupsGroupIdMailingListPreviewGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.previewMailingListApiV1GroupsGroupIdMailingListPreviewGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Revoke one of the current member\'s API keys.
     * Revoke My Api Key
     */
    revokeMyApiKeyApiV1ProfilesMeApiKeysKeyHashDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['keyHash'] == null) {
                throw new runtime.RequiredError('keyHash', 'Required parameter "keyHash" was null or undefined when calling revokeMyApiKeyApiV1ProfilesMeApiKeysKeyHashDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/api-keys/{key_hash}`.replace(`{${"key_hash"}}`, encodeURIComponent(String(requestParameters['keyHash']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Revoke one of the current member\'s API keys.
     * Revoke My Api Key
     */
    revokeMyApiKeyApiV1ProfilesMeApiKeysKeyHashDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.revokeMyApiKeyApiV1ProfilesMeApiKeysKeyHashDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Sync Mailing List
     */
    syncMailingListApiV1GroupsGroupIdMailingListSyncPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling syncMailingListApiV1GroupsGroupIdMailingListSyncPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/{group_id}/mailing-list/sync`.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => MailingListPreviewFromJSON(jsonValue));
        });
    }
    /**
     * Sync Mailing List
     */
    syncMailingListApiV1GroupsGroupIdMailingListSyncPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.syncMailingListApiV1GroupsGroupIdMailingListSyncPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Unsubscribe
     */
    unsubscribeApiV1ProfilesProfileIdUnsubscribePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileId'] == null) {
                throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling unsubscribeApiV1ProfilesProfileIdUnsubscribePost().');
            }
            if (requestParameters['token'] == null) {
                throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling unsubscribeApiV1ProfilesProfileIdUnsubscribePost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters['token'] != null) {
                headerParameters['token'] = String(requestParameters['token']);
            }
            const response = yield this.request({
                path: `/api/v1/profiles/{profile_id}/unsubscribe`.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Unsubscribe
     */
    unsubscribeApiV1ProfilesProfileIdUnsubscribePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unsubscribeApiV1ProfilesProfileIdUnsubscribePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Group
     */
    updateGroupApiV1GroupsGroupIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling updateGroupApiV1GroupsGroupIdPut().');
            }
            if (requestParameters['groupUpdate'] == null) {
                throw new runtime.RequiredError('groupUpdate', 'Required parameter "groupUpdate" was null or undefined when calling updateGroupApiV1GroupsGroupIdPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/groups/{group_id}`.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: GroupUpdateToJSON(requestParameters['groupUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GroupFromJSON(jsonValue));
        });
    }
    /**
     * Update Group
     */
    updateGroupApiV1GroupsGroupIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateGroupApiV1GroupsGroupIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update My Profile
     */
    updateMyProfileApiV1ProfilesMePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myProfileUpdate'] == null) {
                throw new runtime.RequiredError('myProfileUpdate', 'Required parameter "myProfileUpdate" was null or undefined when calling updateMyProfileApiV1ProfilesMePut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: MyProfileUpdateToJSON(requestParameters['myProfileUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
        });
    }
    /**
     * Update My Profile
     */
    updateMyProfileApiV1ProfilesMePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateMyProfileApiV1ProfilesMePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update Profile
     */
    updateProfileApiV1ProfilesProfileIdPutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['profileId'] == null) {
                throw new runtime.RequiredError('profileId', 'Required parameter "profileId" was null or undefined when calling updateProfileApiV1ProfilesProfileIdPut().');
            }
            if (requestParameters['profileUpdate'] == null) {
                throw new runtime.RequiredError('profileUpdate', 'Required parameter "profileUpdate" was null or undefined when calling updateProfileApiV1ProfilesProfileIdPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/{profile_id}`.replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters['profileId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ProfileUpdateToJSON(requestParameters['profileUpdate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProfileFromJSON(jsonValue));
        });
    }
    /**
     * Update Profile
     */
    updateProfileApiV1ProfilesProfileIdPut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateProfileApiV1ProfilesProfileIdPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Upload Avatar
     */
    uploadAvatarApiV1ProfilesMeAvatarPostRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/profiles/me/avatar`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetUploadUrlResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upload Avatar
     */
    uploadAvatarApiV1ProfilesMeAvatarPost(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.uploadAvatarApiV1ProfilesMeAvatarPostRaw(initOverrides);
            return yield response.value();
        });
    }
}
